var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pay-failure-page" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("svg-icon", {
          attrs: { "class-name": "failure-icon", "icon-class": "pay-failure" }
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("message.payFailure")))]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("message.ifItDidNotRedirect")))])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }